import { TicketLineDTO, SoldProductType, Res, Permission } from 'core/api';
import { Result } from 'core/infrastructure';
import { Preconditions } from 'core/infrastructure-next';
import { Command } from 'pos/common';
import * as SalesStore from '../SalesStore';
import { CustomerDisplay } from 'pos/services';
import { Message } from 'core/ui-next/modal';

declare global {
	interface CommandType {
		setTicketLineCashDiscount: (line: TicketLineDTO, discount: number) => Promise<Result>
	}
}

Command.register('setTicketLineCashDiscount', Preconditions.ensure(Permission.Ticket_SetTicketLineCashDiscount), async (line: TicketLineDTO, discount: number): Promise<Result> => {
	if (line.Type === SoldProductType.MenuItem) {
		await Message.show(Res.Msg.MSG_CANNOT_ESTABLISH_DISCOUNTS_IN_MENU_ITEM_LINE());
		return Result.error();
	}

	await SalesStore.setLineCashDiscount(line, discount);
	await CustomerDisplay.displayLineCashDiscount(SalesStore.getTicket(), SalesStore.getLineById(line.Id));
	return Result.ok();
});